import React from 'react'
import styled from 'styled-components'
import JSConfetti from 'js-confetti'

const jsConfetti = new JSConfetti()
const Button = ({title, type, disableNo,setStage, setDisableNo}) => {
    const [noHeight, setNoHeight] = React.useState(4)
    const [noWidth, setNoWidth] = React.useState(8)

    const trigger = () => {
        setDisableNo(true)
        setStage(prevStage => prevStage + 1)
    jsConfetti.addConfetti({
        emojis: ['🦄', '🌸', '🐝', '💞', '💕','💓','💖', '🐝'],
        confettiNumber: 100,
        confettiColors: [
            '#ff0a54', '#ff477e', '#ff7096', '#ff85a1', '#fbb1bd', '#f9bec7',
          ],
      })
      setTimeout(() => {
        // setMessage('Timeout completed!');
          setDisableNo(true)
        jsConfetti.addConfetti({
            // emojis: ['🦄', '🌸', '🐝', '💞', '💕','💓','💖', '🐝'],
            confettiNumber: 100,
            confettiColors: [
                '#ff0a54', '#ff477e', '#ff7096', '#ff85a1', '#fbb1bd', '#f9bec7',
              ],
          })
      }, 2000);
      setTimeout(() => {
        // setMessage('Timeout completed!');
        jsConfetti.addConfetti({
            emojis: ['🦄', '🌸', '🐝', '💞', '💕','💓','💖', '🐝'],
            confettiNumber: 100,
            confettiColors: [
                '#ff0a54', '#ff477e', '#ff7096', '#ff85a1', '#fbb1bd', '#f9bec7',
              ],
          })

      }, 4000);
    }
    const No = () => {
        jsConfetti.clearCanvas();
        setNoWidth(prevState => prevState - 1)
        setNoHeight(prevState => prevState - 1)
        alert("Better Press Yes")
        // jsConfetti.addConfetti({
        //     emojis: ['🥲', '😭'],
        //     confettiNumber: 100,
        //     confettiColors: [
        //         '#ff0a54', '#ff477e', '#ff7096', '#ff85a1', '#fbb1bd', '#f9bec7',
        //       ],
        //   })
        //   setTimeout(() => {
        //     // setMessage('Timeout completed!');
        //     jsConfetti.addConfetti({
        //         emojis: ['🥲', '😭'],
        //         confettiNumber: 100,
        //         confettiColors: [
        //             '#ff0a54', '#ff477e', '#ff7096', '#ff85a1', '#fbb1bd', '#f9bec7',
        //           ],
        //       })
        //   }, 2000);
        //   setTimeout(() => {
        //     // setMessage('Timeout completed!');
        //     jsConfetti.addConfetti({
        //         emojis: ['🥲', '😭'],
        //         confettiNumber: 100,
        //         confettiColors: [
        //             '#ff0a54', '#ff477e', '#ff7096', '#ff85a1', '#fbb1bd', '#f9bec7',
        //           ],
        //       })
        //   }, 4000);
        }
  return (
    <Button.Wrapper type={type} width={`${noWidth}rem`} height={`${noHeight}rem`} disabled={type=== 'YES' ? false : disableNo === true? disableNo : false} onClick={type=== "NO" ? No : trigger}>{title || "YES"}</Button.Wrapper>
  )
}
Button.Wrapper = styled.button`
    border-radius: 1rem;
    margin: 0 2px;
    color: white;
    font-size: 1.4rem;
    text-transform: capitalize;
    width: ${props => props.type === "NO" ? props.width : "8rem"};
    background-color: ${props => props.type === "NO" ? " #924a4a30" : "deeppink"};
    height: ${props => props.type === "NO" ? props.height : "4rem"};;

`
export default Button